import React, { useState } from "react";
import { Box, Popover } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const colorOptions = [
	"#FF6B6B",
	"#C81D25",
	"#FF9F1C",
	"#FFBF69",
	"#FFD23F",
	"#E2D810",
	"#8AC926",
	"#2EC4B6",
	"#00A896",
	"#1F7A8C",
	"#118AB2",
	"#073B4C",
	"#3A86FF",
	"#8338EC",
	"#9D4EDD",
	"#C77DFF",
	"#5A189A",
	"#7209B7",
	"#FF006E",
	"#FF5D8F",
	"#F72585",
	"#E63946",
	"#6D597A",
	"#4ECDC4",
	"#1B998B",
	"#38B000",
	"#70E000",
	"#9EF01A",
	"#FFCA3A",
	"#1982C4",
];

export default function ColorDisplayAndPicker({
	color,
	onColorChange,
	isEditable,
}) {
	const [anchorEl, setAnchorEl] = useState(null);

	const theme = useTheme();

	const boxStyles = {
		minWidth: "15px",
		maxWidth: "15px",
		height: "15px",
		borderRadius: "3px",
		mr: 1,
	};
	const colorDisplayStyles = {
		backgroundColor: color ? color : theme.palette.categories.default,
		cursor: isEditable ? "pointer" : "default",
	};

	const colorBoxStyles = (isSelected, col) => {
		return {
			width: "20px",
			height: "20px",
			cursor: "pointer",
			backgroundColor: isSelected ? "transparent" : col,
			border: isSelected ? `3px solid ${col}` : "none",
			borderRadius: "4px",
			transition: "all 0.15s ease",
			"&:hover": {
				transform: "translateY(-3px)",
			},
		};
	};

	const handleColorClick = (event) => {
		if (!isEditable) return;
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<>
			<Box
				sx={{ ...boxStyles, ...colorDisplayStyles }}
				onClick={(e) => handleColorClick(e)}
			/>
			<Popover
				disableEnforceFocus
				open={Boolean(anchorEl)}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
				sx={{
					"& .MuiPaper-root": {
						overflow: "visible",
						borderRadius: 2,
						padding: 1,
					},
				}}
			>
				<Box
					sx={{
						display: "grid",
						gridTemplateColumns: "repeat(6, 20px)",
						gap: 2,
						width: "fit-content",
					}}
				>
					{colorOptions.map((col) => {
						const isSelected = col === color;

						return (
							<Box
								key={col}
								sx={colorBoxStyles(isSelected, col)}
								onClick={() => {
									if (color !== col) {
										onColorChange(col);
									}
									handleClose();
								}}
							/>
						);
					})}
				</Box>
			</Popover>
		</>
	);
}
